import getLinkText from "../../../helpers/getLinkText";
import getPageName from "../../../helpers/getPageName";
import getPageBrand from "../../../helpers/getPageBrand";
import { trackEvent } from "../../../trackEvent";
import getItemRelated from "../../../helpers/getItemRelated";

/**
 * Push any external links to datalayer based on the below regex
 */

const test = ({ link, isInternal }) => /^((http|https):\/\/)?(([\w.-]*)\.([\w]))(\/[^\\?$]*)?/g.test(link) && !isInternal.test(link);

const push = ({ link, target }) => trackEvent({
  event: "click_outbound_link",
  event_type: "click",
  element_text: getLinkText({ link, target }),
  element_url: link,
  item_related: getItemRelated({ target }) || getPageBrand() || getPageName(),
});

export default {
  name: "external",
  test,
  push
};